import React, { useState } from "react";
import { createPortal } from "react-dom";
import { getBackgroundImage, transformToHtml } from "../../../utils/CommonUtils";

function waitFor(ms) {
  return () => new Promise((resolve) => setTimeout(resolve, ms));
}

function SocialShareButton({ url, title, iconClass }) {
  const handleClick = () => {
    if (url && typeof window !== "undefined") {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <span
      className={`share-social-icon ${iconClass}`}
      title={title}
      onClick={handleClick}
      onKeyDown={(e) => e.key === "Enter" && handleClick()}
      role="button"
      tabIndex={0}
      aria-label={title}
    />
  );
}

export default function ShareCta({ shareCta, logEvent }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (typeof navigator !== "undefined" && shareCta?.data?.url) {
      navigator.clipboard.writeText(shareCta.data.url);
      setCopied(true);
      waitFor(1500)().then(() => setCopied(false));
    }
  };

  const clickHandler = () => {
    setOpen(true);
    if (shareCta?.tracking && logEvent) {
      logEvent(shareCta.tracking);
    }
  };

  const getSocialShareItems = () => {
    if (!shareCta?.data?.data) return [];
    const items = [];
    const { whatsappUrl, fbUrl, mailUrl } = shareCta.data.data;
    if (whatsappUrl) {
      items.push({ url: whatsappUrl, title: "WhatsApp", iconClass: "whatsapp" });
    }
    if (fbUrl) {
      items.push({ url: fbUrl, title: "Facebook", iconClass: "facebook" });
    }
    if (mailUrl) {
      items.push({ url: mailUrl, title: "Gmail", iconClass: "gmail" });
    }
    return items;
  };

  const overlay =
    open &&
    shareCta?.data &&
    typeof document !== "undefined" &&
    document.body &&
    createPortal(
      <div
        className="share-overlay-backdrop"
        onClick={() => setOpen(false)}
        role="presentation"
      >
        <div
          className="share-overlay-content"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-label="Share with friends"
        >
          <div className="share-overlay-title fontSize24 blackFont appendBottom8">
            Share with friends
          </div>
          <div className="fontSize14 boldFont appendBottom8">Sharing link</div>
          {shareCta.data.url && (
            <div className="share-link-row appendBottom20 br8">
              <span className="share-link-text">{shareCta.data.url}</span>
              <button
                type="button"
                className="share-copy-btn"
                onClick={handleCopy}
              >
                <span className="fontSize14 boldFont">
                  {copied ? "Copied!" : "Copy Link"}
                </span>
              </button>
            </div>
          )}
          <div className="fontSize14 boldFont appendBottom8">Or share on</div>
          {shareCta.data.data && (
            <div className="makeFlex gap16 share-social-row">
              {getSocialShareItems().map((item) => (
                <SocialShareButton
                  key={item.title}
                  url={item.url}
                  title={item.title}
                  iconClass={item.iconClass}
                />
              ))}
            </div>
          )}
        </div>
      </div>,
      document.body
    );

  return (
    <>
      {shareCta && (
        <button
          type="button"
          className="share-cta-btn"
          onClick={clickHandler}
          aria-label="Share"
        >
          <div className="makeFlex hrtlCenter share-cta-btn-inner">
            {shareCta.text && (
              <span className="share-cta-text">{transformToHtml(shareCta.text)}</span>
            )}
            {shareCta.icon && (
              <span
                className="bgProperties share-cta-icon"
                style={getBackgroundImage(shareCta.icon)}
              />
            )}
          </div>
        </button>
      )}
      {overlay}
    </>
  );
}
